function getFocusableElements(element) {
  if (!element || !(element instanceof HTMLElement)) return [];
  const focusables = ['button:not([disabled])', '[href]:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', 'option:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'];
  return Array.from(element.querySelectorAll(focusables.join(',')));
}

export { getFocusableElements as g };
//# sourceMappingURL=getFocusableElements-73f83f90-0ab4a5e4.js.map
